export default __webpack_public_path__ + "static/media/College.b013dfcc.png";